import React from "react";

// Lightweight error boundary — stops a single component crash from blanking
// the entire Admin page. On error, shows a friendly inline message and lets
// the user keep working with the rest of the panel.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info?.componentStack);
  }

  reset = () => this.setState({ error: null });

  render() {
    if (this.state.error) {
      return (
        <div
          data-testid="admin-error-boundary"
          className="m-4 p-4 rounded-xl bg-red-50 border-2 border-red-400 text-red-800"
        >
          <p className="font-heading font-bold">⚠️ Bir şey ters gitti</p>
          <p className="text-xs mt-1">
            {String(this.state.error?.message || this.state.error)}
          </p>
          <button
            onClick={() => { this.reset(); window.location.reload(); }}
            className="mt-3 h-10 px-4 bg-red-600 hover:bg-red-700 text-white rounded-full text-sm font-bold"
          >
            Sayfayı Yenile
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
